export function toggle() {
    let toggleInputs = document.querySelectorAll('[data-toggle]');

    toggleInputs.forEach(input => {
        let label = input.nextElementSibling;
        let offText = label.getAttribute('data-offText');
        let onText = label.getAttribute('data-onText');

        function toggleStatus() {
            if (input.checked) {
                label.textContent = onText;
            } else {
                label.textContent = offText;
            }
        }

        input.addEventListener('change', toggleStatus);
    })
}
